import React from 'react';
import { useI18n } from '../../../../contexts/I18nContext';

const ReferenceToVideoUpload = ({
  files,
  inputRef,
  onPick,
  onPreview,
  onRemove
}) => {
  const { t } = useI18n();

  return (
    <div className="veo2-section">
      <div className="veo2-section__title">{t('videoGeneration.veo.upload.clickOrDrag')}</div>
      <div className="veo2-divider" />
      <div className={`veo2-upload ${files.length ? 'has-file' : ''}`} onClick={() => inputRef.current && inputRef.current.click()}>
        <div className="veo2-upload__inner">
          <div className="veo2-upload__icon">⬆︎</div>
          <div className="veo2-upload__title">{files.length ? t('videoGeneration.veo.upload.selectedCount', { count: files.length }) : t('videoGeneration.veo.upload.clickOrDrag')}</div>
          <div className="veo2-upload__desc">{t('videoGeneration.veo.upload.formats')}</div>
        </div>
        <input ref={inputRef} type="file" accept=".jpg,.jpeg,.png,.webp" multiple onChange={onPick} hidden />
      </div>
      {files.length > 0 && (
        <div className="veo2-upload__count">{t('videoGeneration.veo.upload.imagesCount', { count: files.length })}</div>
      )}
      <div className="veo2-info">
        {t('videoGeneration.veo.reference.info')}
      </div>
      {files.length > 0 && (
        <div className="veo2-thumblist">
          {files.map((f, idx) => (
            <div
              key={idx}
              className="veo2-thumb"
              onClick={() => onPreview(f)}
            >
              <img className="veo2-thumb__img" src={URL.createObjectURL(f)} alt={`ref-${idx + 1}`} />
              <span className="veo2-thumb__num">{idx + 1}</span>
              <button className="veo2-thumb__remove" onClick={(e) => { e.stopPropagation(); onRemove(idx); }}>×</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ReferenceToVideoUpload;
